
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    Selectize: () => import("vue2-selectize"),
    SortBox: () => import("@/components/SortBox.vue"),
    Slick: () => import("vue-slick"),
    Modal: () => import("@/components/Modal.vue")
  }
})
export default class UsersIndex extends Vue {
  reinsurers: any = [];
  reinsurer: any = {
    name: '',
    business_name: '',
    cuit: '',
    direction: '',
    floor: '',
    door_number: '',
    countryId: '',
    telephone: ''
  };
  fieldsValidation: any = {
    name: false,
    business_name: false,
    cuit: false,
    direction: false,
    countryId: false
  }
  countries: any = [];
  error: boolean = false;
  currentReinsurer: number = 0;
  sortColumns: Record<string, string> = {
    0: "Nuevo reasegurador",
    1: "Listado de reaseguradores"
  };
  selectizeOptions: Record<string, any> = {
    delimiter: ",",
    persist: false
  };
  slickOptions: Record<string, any> = {
    slidesToShow: 2,
    centerPadding: "60px",
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          arrows: false,
          dots: false
        }
      }
    ]
  };

  async save() {
    if(this.validateData()) {
      try {
        let data: any = this.reinsurer;
        if ((this.reinsurer as any).id) {
          await (this.$root as any)._put(`reinsurers/${(this.reinsurer as any).id}`, data);
        } else {
          await (this.$root as any)._post(`reinsurers`, data);
        }
        this.loadReinsurers(1);
        this.reinsurer = {};
        (this.$refs.slick as any).goTo(1);
        (this.$root as any).notify("El reasegurador ha sido creado con éxito.");
      } catch (e) {
        (this.$root as any).notify("No se pudo crear el reasegurador.", "error");
      }
    } else {
      (this.$root as any).notify("Hay campos requeridos faltantes. Por favor, verifique y vuelva a intentarlo.", "error")
    }
  }

  validateData() {
    let validated = true;
    let reinsurer = this.reinsurer;

    if(this.isEmpty(reinsurer.name)) {
      this.fieldsValidation.name = true;
      validated = false;
    } else this.fieldsValidation.name = false;

    if(this.isEmpty(reinsurer.business_name)) {
      this.fieldsValidation.business_name = true;
      validated = false;
    } else this.fieldsValidation.business_name = false;

    if(this.isEmpty(reinsurer.direction)) {
      this.fieldsValidation.direction = true;
      validated = false;
    } else this.fieldsValidation.direction = false
    
    if(reinsurer.countryId === '') {
      this.fieldsValidation.countryId = true;
      validated = false;
    } else this.fieldsValidation.countryId = false;
        
    return validated;
  }
  
  isEmpty(value) {return value.trim().length === 0}

  isNumber (evt: KeyboardEvent): void {
    const keysAllowed: string[] = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    const keyPressed: string = evt.key;
    
    if (!keysAllowed.includes(keyPressed)) {
           evt.preventDefault()
    }
  }

  cancel() {
    this.reinsurer = {};
    (this.$refs.slick as any).goTo(1);
  }

  async deleteReinsurer() {
    try {
      let response: any = await (this.$root as any)._delete(
        `reinsurers/${this.currentReinsurer}`
      );
      this.loadReinsurers(1);
      (this.$refs.alertUserModal as any).hide();
      (this.$refs.deleteModal as any).hide();
      (this.$root as any).notify("El reasegurador ha sido eliminado con éxito.");
    } catch (e) {
      (this.$root as any).notify("No se pudo eliminar el reasegurador.", "error");
    }
  }

  async verifyAsignedUsers(id: number) {
    this.currentReinsurer = id;
    try {
      let users: any = await (this.$root as any)._get(
        `reinsurers/${id}/users`
      );

      if(users.totalRows > 0) {
        (this.$refs.alertUserModal as any).show();
      } else {
        this.currentReinsurer = id;
        (this.$refs.deleteModal as any).show();
      }
    } catch (e) {
      (this.$root as any).notify("No se pudo continuar con la eliminación del reasegurador.", "error");
    }
  }

  loadReinsurer(reinsurer: any) {
    this.reinsurer= reinsurer;
    (this.$refs.slick as any).goTo(0);
  }

  init() {
    this.loadCountries();
    this.loadReinsurers(1);
  }

  move(index) {
    (this.$refs.slick as any).goTo(index);
  }

  async loadReinsurers(page: number) {
    const response: any = await (this.$root as any)._get("reinsurers/");
    this.reinsurers = response.data;
  }

  async loadCountries() {
    const response: any = await (this.$root as any)._get("countries/all");
    this.countries = response.data;
  }
}
